<template>
  <div class="main-content-container mb-5">
    <div class="top-content-container">
      <b-row>
        <b-col md="9">
          <b-breadcrumb class="customer-breadcrumbs">
            <b-breadcrumb-item
              @click="navigateToCustomersList"
              v-if="$route.meta.customers"
            >
              <span class="text-uppercase font-family-medium">
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              @click="navigateToCustomerDetails"
              v-if="$route.meta.customers"
            >
              <span class="text-uppercase font-family-medium">
                {{ customerFullName }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="$route.meta.tasks">
              <span
                @click="navigateToTasks"
                class="text-uppercase font-family-medium"
              >
                Tasks
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item>
              <span
                class="text-uppercase font-family-medium"
                @click="navigateToWeekly"
              >
                Weekly
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                Add Weekly
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12" lg="9" class="customer-dropdown-column">
          <ValidationObserver ref="selectedCustomer">
            <ValidationProvider name="selectedCustomer" rules="required">
              <b-form-group
                v-if="!isLoadingCustomers"
                label="Customer *"
                class="weekly-form-group"
              >
                <b-form-select
                  class="mb-2 position-relative "
                  :options="eligibleCustomersList"
                  @change="getSelectedCustomer"
                  v-model="selectedCustomer"
                  :disabled="btnDisabled"
                >
                </b-form-select>
              </b-form-group>
              <h6
                v-if="customerValid === false"
                style="margin-bottom: -1.8rem"
                class="font-sm font-family-regular danger ml-2"
              >
                This field is required
              </h6>
            </ValidationProvider>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-row class=" mt-4">
        <b-col class="" cols="12" lg="9">
          <ValidationObserver ref="title">
            <ValidationProvider
              name="Title"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group label="Title *" class="weekly-form-group">
                <b-form-input
                  class="mb-4"
                  type="text"
                  v-model="title"
                  :disabled="btnDisabled"
                  placeholder="Add title of weekly"
                ></b-form-input>
                <h6
                  style="margin-bottom: -1.8rem"
                  v-if="errors[0]"
                  class="font-sm font-family-regular danger"
                >
                  This field is required
                </h6>
              </b-form-group>
            </ValidationProvider>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="" cols="12" lg="9">
          <ValidationObserver>
            <ValidationProvider name="rte" rules="required">
              <p class="font-family-medium">Description *</p>
              <quill-editor
                ref="quillEditor"
                class="quill-custom weekly-desc"
                v-model="content"
                :options="editorOptions"
                :disabled="btnDisabled"
                @change="onEditorChange($event)"
              />
              <input
                ref="imageInput"
                class="d-none"
                type="file"
                accept="image/*"
                @change="_doImageUpload"
              />
              <h6
                v-if="contentValid === false"
                style="margin-bottom: -2rem"
                class="font-sm font-family-regular danger ml-2 mt-4"
              >
                Description is required
              </h6>
            </ValidationProvider>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-row v-if="showAlert">
        <b-col md="12" class="position-relative">
          <b-alert
            class="alert-btn-top custom-alert ml-3"
            :show="showAlert"
            :fade="true"
            >{{ alertMsg }}</b-alert
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="addNotes"
            :disabled="btnDisabled"
            class="btn-pill save-button py-3 px-5 mb-5 mt-3"
          >
            <b-spinner
              v-if="isLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${isLoading ? "" : saveBtnText}` }}</b-button
          >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { quillEditor } from "vue-quill-editor";
import { getProfile } from "@/apis/auth";
import { getAssistantCustomers, getCustomerDetails } from "@/apis/customers";
import { addWeeklyNotes } from "@/apis/assistants";
import { beforeRouteLeave, dirty } from '@/utils/utils'
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";
import { mapState } from "vuex";
import { editorOptions } from '@/utils/constants'

export default {
  name: "AddWeeklyTasks",
  components: {
    quillEditor,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      customerFullName: "",
      alertDuration: null,
      showAlert: false,
      alertMsg: "",
      content: "",
      saveBtnText: "Save",
      saved: false,
      isLoading: false,
      isLoadingCustomers: true,
      title: "",
      assistantProfileId: "",
      eligibleCustomersList: [{ text: "Select customer name", value: null }],
      selectedCustomer: null,
      editorOptions,
      titleValid: null,
      contentValid: null,
      customerValid: null
    };
  },
  computed: {
    quillInstance() {
      return this.$refs.quillEditor.quill;
    },
    btnDisabled() {
      return this.isLoading || this.saved;
    },
    dirty() {
      if (this.saved) {
        return false
      }
      return this.selectedCustomer !== null || this.content.length > 0 || this.title.length > 0
    },
    ...mapState("authModule", ["role"])
  },
  watch: {
    dirty
  },
  created() {
    if (this.$route.params.name) {
      this.customerFullName = this.$route.params.name;
    } else if (this.$route.meta.customers) {
      getCustomerDetails(this.$route.params.profileId)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.customerFullName = `${firstName} ${lastName}`;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if (this.$route.params.profileId && this.$route.meta.customers) {
      this.selectedCustomer = this.$route.params.profileId;
    } else if (this.$route.params.selectedCustomer) {
      this.selectedCustomer = this.$route.params.selectedCustomer;
    } else {
      this.selectedCustomer = null;
    }
    getProfile()
      .then(res => {
        this.assistantProfileId = res.data.defaultProfile.id;
        getAssistantCustomers(this.assistantProfileId, {})
          .then(res => {
            this.eligibleCustomersList = [...res.data.results]
            .filter(customer => customer.customer.profile)
            .map(item => {
              return {
                text: `${item.customer.profile.user.firstName} ${item.customer.profile.user.lastName}`,
                value: item.customer.profile.id
              };
            });
            this.eligibleCustomersList.unshift({
              value: null,
              text: "Select customer name"
            });
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingCustomers = false;
          });
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    navigateToCustomersList() {
      this.$router.push({
        name: "DedicatedCustomers"
      });
    },
    navigateToCustomerDetails() {
      this.$router.push({
        name: "CustomerDetails",
        params: {
          profileId: this.selectedCustomer
        },
        query: {
          tab: 2
        }
      });
    },
    getSelectedCustomer() {
      if (this.selectedCustomer) {
        this.customerValid = true;
      } else {
        this.customerValid = false;
      }
    },
    stripTagsAndCheckValidity() {
      let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();

      const imgRegex = /<img[^>]*>/g;

      // Check if the html entered in the editor has images.
      // Add dummy text to strippedContent to prevent validation error
      // when only an image is uploaded, no text
      if (
        this.content.match(imgRegex) &&
        this.content.match(imgRegex).length > 0 &&
        strippedContent.length === 0
      ) {
        strippedContent = "a";
      }

      if (strippedContent.length === 0) {
        this.contentValid = false;
      } else {
        this.contentValid = true;
      }
    },
    onEditorChange({ html }) {
      this.content = html;
      this.stripTagsAndCheckValidity();
    },
    showImageUI() {
      this.$refs.imageInput.click();
    },
    async _doImageUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      let previewImage;
      reader.onload = e => {
        previewImage = e.target.result;
        // get current index of the cursor
        const currentIndex = this.quillInstance.selection.lastRange.index;
        // insert uploaded image url to 'image' embed (quill does this for you)
        // the embed looks like this: <img src="{url}" />
        this.quillInstance.insertEmbed(currentIndex, "image", previewImage);
        // set cursor position to after the image
        this.quillInstance.setSelection(currentIndex + 1, 0);
      };
    },
    navigateToTasks() {
      if (this.$route.name === "AddWeeklyTaskCustomer") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 0
          }
        });
      } else if (this.$route.name === "AddWeeklyTask") {
        this.$router.push({
          name: "TaskDashboard"
        });
      }
    },
    navigateToWeekly() {
      if (this.$route.name === "AddWeeklyTaskCustomer") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 3
          }
        });
      } else if (this.$route.name === "AddWeeklyTask") {
        if (this.role === "assistant") {
          this.$router.push({
            name: "PAWeeklyTasks",
            params: {
              profileId: this.$route.params.profileId
            }
          });
        } else if (this.role === "admin") {
          this.$router.push({ name: "AllWeeklyTasks" });
        }
      }
    },
    addNotes() {
      this.$refs.title
        .validate()
        .then(val => {
          this.titleValid = val;
        })
        .then(() => {
          if (!this.selectedCustomer) {
            this.customerValid = false;
          } else if (this.selectedCustomer) {
            this.customerValid = true;
          }
          this.stripTagsAndCheckValidity();
        })
        .finally(() => {
          if (this.titleValid && this.customerValid && this.contentValid) {
            this.isLoading = true;

            const payload = {
              title: this.title,
              notes: this.content,
              participent: this.selectedCustomer,
              organizer: this.assistantProfileId
            };
            addWeeklyNotes(this.assistantProfileId, payload)
              .then(() => {
                this.showAlert = true;
                this.alertMsg = "Added note successfully!";
                this.saved = true;
                this.saveBtnText = "Saved";
                this.$router.go(-1);
                this.isLoading = false;
              })
              .catch(err => {
                this.showAlert = true;
                if (err.response.status === 401) {
                  this.alertMsg =
                    "User token expired. Please logout and login again";
                } else {
                  this.alertMsg = "Some error occured";
                }
                console.log(err);
                this.isLoading = false;
              });
          } else if (
            !this.titleValid ||
            !this.customerValid ||
            !this.contentValid
          ) {
            this.showAlert = true;
            this.alertMsg = "There are invalid form fields";
          }
        });
    },
    onBeforeUnload(event) {
      event.returnValue = "Some dummy value"
    },
  },
  beforeDestroy() {
    this.$store.commit({
      type: 'removeUnloadListener',
      onBeforeUnload: this.onBeforeUnload
    })
  },
  beforeRouteLeave
};
</script>

<style scoped lang="scss">
.customer-select {
  top: 0.5rem;
}
.custom-caret {
  position: absolute;
  right: 1rem;
  top: 2.2rem;
  z-index: 52;
}
.customer-dropdown-column {
  justify-content: flex-end;

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
}
</style>
